import { Star, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export default function Testimonials() {
  const { content } = useContent();
  if (!content) return <section id="testimonials" className="py-16 md:py-28" />;
  const items = content.testimonials || [];

  return (
    <section id="testimonials" className="py-16 md:py-28" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="Customer feedback"
          title="What our customers say"
          sub="Real feedback from people who made IPTV HUB their entertainment hub."
        />
        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {items.map((t, i) => (
            <Reveal key={t.name + i} delay={i * 0.08} className="h-full">
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="glass glass-hover relative flex h-full flex-col rounded-2xl p-7"
              >
                <Quote className="mb-4 h-6 w-6 text-electric/60" fill="currentColor" aria-hidden="true" />
                <blockquote className="flex-1 text-sm leading-relaxed text-slate-600">“{t.text}”</blockquote>
                <figcaption className="mt-6 border-t border-slate-900/10 pt-5">
                  <div className="mb-2 flex gap-0.5" aria-label={`${t.rating} out of 5 stars`}>
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star
                        key={s}
                        className={`h-3.5 w-3.5 ${s < (t.rating || 5) ? "text-electric" : "text-slate-300"}`}
                        fill="currentColor"
                      />
                    ))}
                  </div>
                  <p className="font-display text-sm font-semibold text-slate-900" data-testid={`testimonial-name-${i + 1}`}>{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
